import { render, staticRenderFns } from "./ReportMealsTabTaken.vue?vue&type=template&id=40a2e994"
import script from "./ReportMealsTabTaken.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabTaken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports